import * as React from 'react'
import classes from './index.module.scss'
import { useTranslations } from 'next-intl'

export const Error: React.FC = () => {
  const t = useTranslations();

  return <div className={classes.error}>{t('forms.defaultError')}</div>
}
